import axios from 'axios';
import { API } from './api';
import { greetOrName, renderTemplate, sharePdfToWhatsApp, signatureCompany, templatesFor } from './waShare';
import { fmtINR } from '../components/admin/billing/shared';

const vehicleText = (v = {}) => {
  const model = [v.make, v.model].filter(Boolean).join(' ');
  const reg = (v.registration_number || '').toUpperCase();
  return model ? `${model}${reg ? ` (${reg})` : ''}` : reg || 'car';
};

const message = (card, variant, reviewUrl) => {
  const c = card.customer_snapshot || {};
  const base = { customer: greetOrName(c.prefix, c.name), vehicle: vehicleText(card.vehicle_snapshot) };
  if (variant === 'ready') {
    const total = Number(card.bill_total ?? card.total ?? 0);
    return renderTemplate(templatesFor('vehicle_ready'), {
      ...base, number: card.number, total: total > 0 ? fmtINR(total) : '',
      total_note: card.bill_is_invoice ? '' : ' (estimate)',
      work: (card.items || []).map((i) => i.name).filter(Boolean).join(', '),
    });
  }
  // The thank-you already carries the review link, so the sign-off skips it.
  return renderTemplate(templatesFor('review_thanks'), { ...base, company: signatureCompany() || 'us', review_link: reviewUrl || '' }, { noReview: true });
};

// Branded "ready for pickup" or "thank you + review QR" card, shared with its message.
export const shareJobCard = (card, authHeader, variant, reviewUrl) => sharePdfToWhatsApp({
  getPdf: () => axios.get(`${API}/job-cards/${card.id}/card`, { params: { variant }, headers: authHeader(), responseType: 'blob' }).then((r) => r.data),
  filename: `${card.number}-${variant}.png`,
  title: `${variant === 'ready' ? 'Ready for pickup' : 'Thank you'} · ${card.number}`,
  message: message(card, variant, reviewUrl),
  phone: card.customer_snapshot?.phone,
  type: 'image/png',
  kind: 'Card',
});
